import debounce from "lodash/debounce"
import { Fragment, useEffect, useState } from "react"
import { FaSearch } from "react-icons/fa"
import { TbChevronRight } from "react-icons/tb"
import { useNavigate } from "react-router-dom"
import {
  BaseTable,
  Button,
  Card,
  FooterMenu,
  HeaderMenu,
  Input,
  Loading,
  PaginationData,
  Select,
  TableHeaderSort,
  TableNumber
} from "../../../../components"
import {
  Delete,
  Detail,
  Update
} from "./components/ChildItem/components/Item/components"
import { IsActive } from "./components/ChildItem/components/Item/components/IsActive"
import FilterTable from "./components/FilterData"
import {
  useDepartement,
  useJobPosition,
  useMainLocation
} from "./components/FormSection/utils"
import { PersonalList } from "./types"
import {
  RenderProvider,
  restrictedData,
  useColumnConfig,
  useExportList,
  useExportPdf,
  useList
} from "./utils"
import { defaultValue, exportExcel } from "./utils/function"
import { PERMISION } from "security"

interface PaginationState {
  total: number
  page: number
  limit: number
  pages: number
  keyword: string
  department?: string
  jobpos?: string
  location?: string
  sort?: string
}
type headerState = { title: string; sort: boolean; align?: "left" | "right" }
export default function CreateNewEmployee(props: { tab?: string }) {
  const [searchData, setSearchData] = useState<any | undefined>({
    department: "",
    jobpos: "",
    location: ""
  })

  const default_pagination_value = {
    total: 0,
    page: 1,
    limit: 10,
    pages: 1,
    keyword: "",
    department: "",
    jobpos: "",
    location: ""
  }

  const { dataDepartement, isLoadingDepartement } = useDepartement()
  const { dataJobPosition, isLoadingJobPosition } = useJobPosition()
  const { dataMainLocation, isLoadingMainLocation } = useMainLocation()
  const { dataColumn, refetchColumn } = useColumnConfig()

  const [pagination, setPagination] = useState<PaginationState>(
    default_pagination_value
  )
  const { data, isLoading, refetch } = useList(pagination)
  const employees = useExportList()
  const exportPdf = useExportPdf({ data: employees.data })
  const onDebounce = debounce((e: any) =>
    setPagination((prev) => {
      return { ...prev, keyword: e.target.value }
    })
  )
  const dataList: PersonalList[] = data.items
  const dataFillter = defaultValue(dataColumn)

  const dataLength = data.pagination_data.size
  const pageCurrent = pagination.page
  const limit = pagination.limit
  const totalData = pagination.total

  const [header, setHeader] = useState<headerState[]>([])

  const sortMapping: Record<string, string> = {
    "ID": "employee_code",
    "NAME": "employee_name",
    "NUMBER OF NATIONALITY ID": "no_nationality",
    "RELIGION": "religion_name",
    "HANDPHONE": "hp",
    "EMAIL":"email",
    "COUNTRY":"country",
    "PROVINCE":"province",
    "REGENCY":"regency",
    "SUBDISTRICT":"subdistrict",
    "VILLAGE":"village",
    "ADDRESS":"address",
    "DEPARTMENT":"department",
    "DIVISI":"divisi",
    "GENDER":"gender",
    "BANK":"bank",
    "ACCOUNT BANK NAME":"account_bank"
  }
  
  const handleSort = (item: string, sortType: string) => {    
    const sortParam = sortMapping[item]
      ? `${sortMapping[item]}:${sortType}`
      : ""
    setPagination({ ...pagination, sort: sortParam, page: 1 })
  }

  const countTrueValues = (obj: Record<string, boolean | undefined>): number => {
    return Object.values(obj).filter(value => value === true).length;
  }
  const trueCount = countTrueValues(dataFillter);

  useEffect(()=>{
    var dataHeader:any = [
      { title: "ID", sort: true },
      { title: "NAME", sort: true },
    ]
    dataFillter.nomorNationalId && dataHeader.push({ title: "NUMBER OF NATIONALITY ID", sort: true })
    dataFillter.religion && dataHeader.push({ title: "RELIGION", sort: true })
    dataFillter.handphone && dataHeader.push({ title: "HANDPHONE", sort: true })
    dataFillter.email && dataHeader.push({ title: "EMAIL", sort: true })
    dataFillter.country && dataHeader.push({ title: "COUNTRY", sort: true })
    dataFillter.province && dataHeader.push({ title: "PROVINCE", sort: true })
    dataFillter.regency && dataHeader.push({ title: "REGENCY", sort: true })
    dataFillter.subdistrict && dataHeader.push({ title: "SUBDISTRICT", sort: true })
    dataFillter.village && dataHeader.push({ title: "VILLAGE", sort: true })
    dataFillter.address && dataHeader.push({ title: "ADDRESS", sort: true })
    dataFillter.departement && dataHeader.push({ title: "DEPARTEMENT", sort: true })
    dataFillter.divisi && dataHeader.push({ title: "DIVISI", sort: true })
    dataFillter.gender && dataHeader.push({ title: "GENDER", sort: true })
    dataFillter.employeeStatus && dataHeader.push({ title: "EMPLOYEE STATUS", sort: true })
    dataFillter.bank && dataHeader.push({ title: "BANK", sort: true })
    dataFillter.branch && dataHeader.push({ title: "BRANCH", sort: true })
    dataFillter.accountBankName && dataHeader.push({ title: "ACCOUNT BANK NAME", sort: true })
    
    setHeader(dataHeader)
  // eslint-disable-next-line  
  },[dataColumn])
  
  return (
    <section className="mb-5">
      <RenderProvider>
        {props?.tab !== "tab" && (
          <HeaderMenu title="DATA ENTRY | CREATE NEW EMPLOYEE" />
        )}

          <div className="sticky top-[125px] py-4 z-[2] bg-white dark:bg-black">
            <Card>
              <Card.Body>
                <div className="lg:flex lg:justify-between lg:items-end">
                  <div className="flex gap-2 mb-3 items-center">
                    <div>
                      <Input
                        label="SEARCH"
                        className="lg:w-[300px] md:w-full"
                        placeholder="Search data..."
                        onChange={onDebounce}
                      />
                    </div>
                    <div className="mt-8">
                    <FilterTable dataList={dataColumn} refetch={refetchColumn} />
                    </div>
                  </div>
                  <div className="flex items-end mb-4 justify-between gap-1">
                    <Create />
                    <Select
                      label="DEPARTMENT"
                      placeholder="Select department"
                      className="lg:w-[200px] md:w-full me-2"
                      width={true}
                      isLoading={isLoadingDepartement}
                      options={[{ label: "ALL", value: "" }, ...dataDepartement]}
                      value={dataDepartement.find(
                        (item) => item.value === searchData?.department ) ?? 
                        { label: "ALL", value: "" }}
                      onChange={(e) =>
                        setSearchData({ ...searchData, department: e?.value })
                      }
                    />
                    <Select
                      label="JOB POSITION"
                      placeholder="Select job position"
                      className="lg:w-[200px] md:w-full me-2"
                      width={true}
                      isLoading={isLoadingJobPosition}
                      options={[{ label: "ALL", value: "" }, ...dataJobPosition]}
                      value={
                        dataJobPosition.find((item) => item.value === searchData?.jobpos) ??
                        { label: "ALL", value: "" }
                      }
                      onChange={(e) =>
                        setSearchData({ ...searchData, jobpos: e?.value })
                      }
                    />
                    <Select
                      label="MAIN LOCATION"
                      placeholder="Select main location"
                      className="lg:w-[200px] md:w-full me-2"
                      width={true}
                      isLoading={isLoadingMainLocation}
                      options={[{ label: "ALL", value: "" }, ...dataMainLocation]}
                      value={dataMainLocation.find(
                        (item) => item.value === searchData?.location) ?? 
                        { label: "ALL", value: "" }}
                      onChange={(e) =>
                        setSearchData({ ...searchData, location: e?.value })
                      }
                    />
                    <Button
                      type="button"
                      color="primary"
                      className="!rounded-lg"
                      onClick={() => {
                        setPagination((prev) => {
                          return {
                            ...prev,
                            department: searchData?.department,
                            jobpos: searchData?.jobpos,
                            location: searchData?.location
                          }
                        })
                      }}>
                      <FaSearch />
                    </Button>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="overflow-auto max-h-[calc(100svh-620px)]">
            <BaseTable className="border-collapse w-full">
              <thead className="sticky top-50 p-1 z-[2] !bg-black !text-white">
                <tr>
                  <th>NO</th>
                  <TableHeaderSort
                    title={header}
                    onSort={(item, sortType) => handleSort(item, sortType)}
                  />
                  <th className="w-[100px]">ACTION</th> 
                </tr>
              </thead>

              <tbody>
                {isLoading || dataList.length === 0 ? (
                  <tr>
                    <td colSpan={9} className="text-center">
                      <Loading
                        loading={isLoading}
                        errorText="No data available"
                      />
                    </td>
                  </tr>
                ) : (
                  <Fragment>
                    {dataList.map((item, key) => {
                      // Vars
                      const isRestricted: boolean = Boolean(
                        restrictedData.find((i) => i === item.employee_code)
                      )

                      return (
                        <tr className="font-normal" key={key}>
                          <td>
                            {TableNumber({
                              dataLength: dataLength,
                              pageCurrent: pageCurrent,
                              index: key,
                              limit: limit,
                              totalData: totalData
                            })}
                          </td>
                          <td>{item.employee_code}</td>
                          <td>{item.employee_name}</td>
                          {dataFillter.nomorNationalId && (
                            <td>{item.nomor}</td>
                          )}
                          {dataFillter.religion && (
                            <td>{item.religion_name}</td>
                          )}
                          {dataFillter.handphone && (
                            <td>{item.handphone}</td>
                          )}
                          {dataFillter.email && <td>{item.email}</td>}
                          {dataFillter.country && (
                            <td>{item.country_name}</td>
                          )}
                          {dataFillter.province && (
                            <td>{item.province_name}</td>
                          )}
                          {dataFillter.regency && (
                            <td>{item.regency_name}</td>
                          )}
                          {dataFillter.subdistrict && (
                            <td>{item.subdistrict_name}</td>
                          )}
                          {dataFillter.village && (
                            <td>{item.village_name}</td>
                          )}
                          {dataFillter.address && <td>{item.address}</td>}
                          {dataFillter.departement && (
                            <td>{item.department_name}</td>
                          )}
                          {dataFillter.divisi && (
                            <td>{item.divisi_name}</td>
                          )}
                          {dataFillter.gender && <td>{item.gender}</td>}
                          {dataFillter.employeeStatus && (
                            <td>{item.employee_status_name}</td>
                          )}
                          {dataFillter.bank && <td>{item.bank_name}</td>}
                          {dataFillter.branch && <td>{item.branch}</td>}
                          {dataFillter.accountBankName && (
                            <td>{item.account_number}</td>
                          )}
                          <td className="flex">
                            {!isRestricted && (<Detail id={item} />)}

                            {!isRestricted && (
                              <Fragment>
                                <Update id={item} />
                                <Delete id={item} refetch={refetch} />
                                <IsActive id={item} refetch={refetch} />
                              </Fragment>
                            )}
                          </td>
                        </tr>
                      )
                    })}
                  </Fragment>
                )}
              </tbody>

              <tbody style={{ border: "none" }} className="!border-none">
                <tr>
                  <td colSpan={4 + trueCount} className="border-0 !border-none !p-0" style={{ border: "none", padding: 0 }}>
                    <Card className="mt-5">
                      <Card.Body>
                        <div className="mt-[-20px]">
                          <PaginationData
                            data={data}
                            pagination={pagination}
                            setPagination={setPagination}
                          />
                        </div>
                      </Card.Body>
                    </Card>
                  </td>
                </tr>
              </tbody>
            </BaseTable>   
          </div>     
          <section className="mt-2">
            <FooterMenu
              export={{
                actiontype: "export",
                onClick: () =>
                  exportExcel({
                    data: employees.data
                  })
              }}
              pdf={{
                actiontype: "pdf",
                onClick: exportPdf.handleExportPdf
              }}
              hasCancelButton
            />
          </section>
      </RenderProvider>
    </section>
  )
}

function Create() {
  const navigate = useNavigate()
  return (
    <Fragment>
      <Button
        permission={PERMISION.CARDS.REGISTER.EMPLOYEE.CREATE}
        color="primary"
        onClick={() =>
          navigate("/cards/transaction/create-new-employee/create")
        }>
        CREATE NEW <TbChevronRight />
      </Button>
    </Fragment>
  )
}
